import type { ChatAttachmentView } from "web_myplann/Chat/Types/chatMessage";

export const restoreChatAttachmentFile = async (
	attachment: ChatAttachmentView,
	cachedFile: File | undefined,
): Promise<File | undefined> => {
	if (cachedFile) return cachedFile;
	if (!attachment.localUrl) return undefined;

	const blob = await fetch(attachment.localUrl)
		.then((response) => response.blob())
		.catch(() => undefined);

	if (!blob) return undefined;

	return new File([blob], attachment.fileName, { type: attachment.mimeType });
};
